var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76661 3.59982C9.96187 3.40455 10.2785 3.40455 10.4737 3.59982L14.5204 7.64648C14.6142 7.74025 14.6668 7.86743 14.6668 8.00004C14.6668 8.13264 14.6142 8.25982 14.5204 8.35359L10.4737 12.4003C10.2785 12.5955 9.96187 12.5955 9.76661 12.4003C9.57135 12.205 9.57135 11.8884 9.76661 11.6931L12.9597 8.50004H2.8335C2.55735 8.50004 2.3335 8.27618 2.3335 8.00004C2.3335 7.72389 2.55735 7.50004 2.8335 7.50004H12.9597L9.76661 4.30692C9.57135 4.11166 9.57135 3.79508 9.76661 3.59982Z",
    fill: "#205ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalRightArrow);
export default __webpack_public_path__ + "static/media/modal-right-arrow.402013b6e9514fb40cfd665af82039a1.svg";
export { ForwardRef as ReactComponent };